import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Module } from '../models';
import { ModuleValue } from '../models';

export const moduleActions = createActionGroup({
    source: 'Module',
    events: {
        // Get
        'Get Module': props<{ id: string }>(),
        'Get Module Success': props<{ payload: Module }>(),
        'Get Module Error': props<{ code: number }>(),
        // Create
        'Create Module': props<{ value: ModuleValue }>(),
        'Create Module Success': props<{ payload: Module }>(),
        'Create Module Error': props<{ code: number }>(),
        // Update
        'Update Module': props<{ id: string; value: ModuleValue }>(),
        'Update Module Success': props<{ payload: Module }>(),
        'Update Module Error': props<{ code: number }>(),
        // Delete
        'Delete Module': props<{ id: string }>(),
        'Delete Module Success': props<{ id: string }>(),
        'Delete Module Error': props<{ code: number }>(),
        // Clear
        Clear: emptyProps(),
    },
});
